import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hook/store';
import { ESliceAuth } from '../../store/slices/authSlice';
import { canReadRunAudit } from '../DeliveryRouteInfo/routeRunAuditScope';
import DeliverySchedule from './DeliverySchedule';

/** Existing bookmarks consolidate for route readers; do not remove legacy-only permissions. */
export default function DeliveryStatusEntry() {
  const auth = useAppSelector(state=>state[ESliceAuth.AuthInfo]);
  return canReadRunAudit(auth.permission, auth.is_active)
    ? <Navigate to="/delivery/delivery-route-info?view=schedule" replace /> : <DeliverySchedule />;
}
